import type { ICellRendererParams } from 'ag-grid-community';
import { Spinner } from 'react-bootstrap';
import SubtleBadge from '@/components/common/SubtleBadge';
import type { UrlHeadCheckResult } from '../api/types';
import { decodeUrlForDisplay } from '../lib/utils';

export type HeadCheckRow = {
  url: string;
  result?: UrlHeadCheckResult;
};

function statusLabel(result: UrlHeadCheckResult): string {
  if (result.ok) return '200';
  if (result.status != null) return String(result.status);
  if (result.error === 'invalid') return 'نامعتبر';
  return 'خطا';
}

function statusTone(
  result: UrlHeadCheckResult,
): 'success' | 'danger' | 'secondary' {
  if (result.ok) return 'success';
  if (result.status != null || result.error) return 'danger';
  return 'secondary';
}

export function headCheckColumnConfig({ running }: { running: boolean }) {
  return [
    {
      field: 'url',
      title: 'آدرس',
      type: 'string',
      flex: 1,
      minWidth: 200,
      searchable: true,
      cellRenderer: (params: ICellRendererParams<HeadCheckRow>) => {
        const row = params.data;
        if (!row) return null;
        const decoded = decodeUrlForDisplay(row.url);
        return (
          <span className="mono if-url-clip" dir="ltr" title={decoded}>
            {decoded}
          </span>
        );
      },
    },
    {
      field: 'result',
      title: 'وضعیت',
      type: 'string',
      width: 100,
      minWidth: 100,
      maxWidth: 110,
      flex: 0,
      suppressSizeToFit: true,
      resizable: false,
      sortable: false,
      suppressHeaderMenuButton: true,
      cellClass: 'd-flex align-items-center justify-content-center',
      cellRenderer: (params: ICellRendererParams<HeadCheckRow>) => {
        const row = params.data;
        if (!row) return null;
        if (!row.result) {
          return running ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <span className="text-secondary fs--2">—</span>
          );
        }
        return (
          <SubtleBadge bg={statusTone(row.result)} pill className="fs--2">
            {statusLabel(row.result)}
          </SubtleBadge>
        );
      },
    },
  ];
}
